import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import { Modal } from 'view-design'
class HttpRequest {
  constructor() {
    this.queue = {}
  }

  getInsideConfig() {
    const config = {
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        authorization: localStorage.getItem('token') || '',
      },
      responseType: 'blob',
    }
    return config
  }

  destroy(url) {
    delete this.queue[url]
  }

  /**
   * 格式化传入的数据
   */
  formatReqData(method, data) {
    const upperCaseMethod = method.toUpperCase()
    let k = ''
    let postData
    switch (upperCaseMethod) {
      case 'POST':
      case 'PUT':
      case 'DELETE':
        k = 'data'
        postData = data
        break
      case 'GET':
        k = 'params'
        postData = data
        break
      default:
        throw new Error('不认识的methods')
    }
    return {
      k,
      postData,
    }
  }

  /**
   * 回到登陆
   */
  toLogin() {
    router.push({
      name: 'login',
    })
  }

  errorMsg(message) {
    Modal.error({
      title: '系统提示',
      content: message,
    })
  }

  /**
   * 错误处理
   */
  async errorCode(res, options) {
    switch (Number(res.code)) {
      case 0: // 正常数据
        return res
      case 401: // 未登录
        this.toLogin()
        break
      case 403: // 没权限
        router.push({
          name: 'error_403',
        })
        break
      case 1:
        this.errorMsg(res.message)
        break
      case 500:
        this.errorMsg(res.message)
        break
      default:
        this.errorMsg(res.message)
        break
    }
  }

  interceptors(instance, url, options) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        this.queue[url] = true
        const { method, data, notError } = config
        const { k, postData } = this.formatReqData(method, data)
        config[k] = postData
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url)
        return res
      },
      error => {
        console.log(error);
        Modal.error({
          title: '系统提示',
          content: error,
        })
        return Promise.reject(error)
      }
    )
  }

  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url, options)
    return instance(options)
  }
}

export default HttpRequest
